import { render, staticRenderFns } from "./ChartWithCalloutsSlide.vue?vue&type=template&id=38be20a3&scoped=true&"
import script from "./ChartWithCalloutsSlide.vue?vue&type=script&lang=js&"
export * from "./ChartWithCalloutsSlide.vue?vue&type=script&lang=js&"
import style0 from "./ChartWithCalloutsSlide.vue?vue&type=style&index=0&id=38be20a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be20a3",
  null
  
)

export default component.exports